import { ConfirmationModal, Typography } from 'seagull';
import pluralize from "../../../../utils/pluralize";
import styles from "./GenerateLinkModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GenerateLinkModal = _ref => {
  let {
    recipientsCount,
    dismissModal
  } = _ref;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    "data-testid": 'generate-link-modal',
    title: "Share by link",
    width: "800px",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.generateModalContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "Generating a shareable link for a proposal means the proposal will not be sent via email through Anchor."
      }), /*#__PURE__*/_jsx(Typography, {
        children: "Please note the following:"
      }), /*#__PURE__*/_jsxs("ul", {
        children: [/*#__PURE__*/_jsx("li", {
          className: styles.listItem,
          children: /*#__PURE__*/_jsx(Typography, {
            children: "The proposal's status will change to \"Sent.\""
          })
        }), /*#__PURE__*/_jsx("li", {
          className: styles.listItem,
          children: /*#__PURE__*/_jsx(Typography, {
            children: "Your client will receive reminders as needed, according to your notification settings."
          })
        }), /*#__PURE__*/_jsx("li", {
          className: styles.listItem,
          children: /*#__PURE__*/_jsx(Typography, {
            children: "Each link is unique to its recipient, so ensure it is shared with the correct person."
          })
        })]
      })]
    }),
    onCloseButtonClick: () => dismissModal(false),
    secondaryButtonLabel: "Cancel",
    secondaryButtonTestid: "generate-link-modal-cancel",
    onSecondaryButtonClick: () => dismissModal(false),
    primaryButtonLabel: "Generate ".concat(pluralize('link', recipientsCount)),
    primaryButtonTestid: "generate-link-modal-generate",
    onPrimaryButtonClick: () => {
      dismissModal(true);
    }
  });
};